import React from "react";
import { ContainerModule } from "../../carlsberg-headless/types/modules/Container";
import { ModulesRenderer } from "../../carlsberg-headless/ModulesRenderer";
import { getReactCMSComponent } from "../../carlsberg-headless/getReactCMSComponent";
import { IterableModule } from "../../carlsberg-headless/types/modules/util/module";
import { TAXONOMIES_MAP } from "../../carlsberg-headless/taxonomies-map";
import { FlexRow, FlexCell } from "@shared-components/FlexGrid/FlexGrid";
import { Container as SharedContainer } from "@shared-components/Container/Container";

export type ContainerProps = ContainerModule;

const Container: React.FC<ContainerProps> = ({ taxonomies, modules }) => {
  if (!modules) {
    return null;
  }

  if (
    taxonomies?.some((v) =>
      Object.values(TAXONOMIES_MAP.container_module).includes(v)
    )
  ) {
    return (
      <SharedContainer>
        <FlexRow spacing={[0, 2, 4]}>
          {(modules as unknown as IterableModule[]).map(
            ({ alias, ...props }, index: number) => {
              props["sx"] = { marginBottom: [6, 6, 0], px: [0, 0, 0] };
              return (
                <FlexCell
                  key={`cell_${props.cbkey}_${index}`}
                  taxonomies={taxonomies}
                >
                  {getReactCMSComponent({
                    alias,
                    props,
                  })}
                </FlexCell>
              );
            }
          )}
        </FlexRow>
      </SharedContainer>
    );
  }

  return <ModulesRenderer modules={modules} />;
};

export { Container };
